import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ending-mobile.jpg'
import _imports_1 from '@/assets/images/ending-mobile@2x.jpg'
import _imports_2 from '@/assets/images/ending-desktop.jpg'
import _imports_3 from '@/assets/images/ending-desktop@2x.jpg'


const _withScopeId = n => (_pushScopeId("data-v-7d9062b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + ' 1x, ' + _imports_1 + ' 2x'
const _hoisted_2 = _imports_2 + ' 1x, ' + _imports_3 + ' 2x'
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"overlay\" data-v-7d9062b3></div><picture class=\"background\" data-v-7d9062b3><source srcset=\"" + _hoisted_1 + "\" media=\"(max-width: 1024px)\" data-v-7d9062b3><source srcset=\"" + _hoisted_2 + "\" data-v-7d9062b3><img src=\"" + _imports_2 + "\" alt=\"\" loading=\"lazy\" data-v-7d9062b3></picture>", 2)

import { useGameState } from '@/services/composition';
  
import UIPanelPause from '@/components/UIPanelPause/UIPanelPause.vue';
import UIPanelEndSuccess from '@/components/UIPanelEndSuccess/UIPanelEndSuccess.vue';
import DesktopEndingIndex from './DesktopEndingIndex.vue';
import UIEscapeSuccess from '@/components/UIEscapeSuccess/UIEscapeSuccess.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ending", [{ 'success': _unref(state).matches('end.success') }]])
  }, [
    _hoisted_3,
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(state).matches('end.initial'))
          ? (_openBlock(), _createBlock(UIEscapeSuccess, { key: 0 }))
          : (_unref(state).matches('end.success'))
            ? (_openBlock(), _createBlock(UIPanelEndSuccess, {
                key: 1,
                class: "panel panel--success"
              }))
            : (_unref(state).matches('end.failed'))
              ? (_openBlock(), _createBlock(UIPanelPause, {
                  key: 2,
                  class: "panel"
                }))
              : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})